import moment from 'moment';

export const defaultFormat: string = 'YYYY-MM-DDTHH:mm:ss Z';

declare module 'moment' {
    interface Moment {
        round(precision, key, direction): moment.Moment;

        floor(precision, key): moment.Moment;

        ceil(precision, key): moment.Moment;
    }
}

export class MomentConfig {
    static config() {
        moment.locale('cs');
        moment.fn.toJSON = function (): string {
            return this.format(defaultFormat);
        };

        moment.fn.round = function (precision, key, direction): moment.Moment {
            direction = direction || 'round';
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const _THIS = this; // cache of this
            const methods = {
                hours: { name: 'Hours', maxValue: 24 },
                minutes: { name: 'Minutes', maxValue: 60 },
                seconds: { name: 'Seconds', maxValue: 60 },
                milliseconds: { name: 'Milliseconds', maxValue: 1000 },
            };
            const keys = {
                mm: methods.milliseconds.name,
                milliseconds: methods.milliseconds.name,
                Milliseconds: methods.milliseconds.name,
                s: methods.seconds.name,
                seconds: methods.seconds.name,
                Seconds: methods.seconds.name,
                m: methods.minutes.name,
                minutes: methods.minutes.name,
                Minutes: methods.minutes.name,
                H: methods.hours.name,
                h: methods.hours.name,
                hours: methods.hours.name,
                Hours: methods.hours.name,
            };
            let value = 0;
            let rounded = false;
            let subRatio = 1;
            let maxValue;

            // make sure key is plural
            if (key.length > 1 && key !== 'mm' && key.slice(-1) !== 's') {
                key += 's';
            }

            key = keys[key].toLowerCase();

            // control
            if (!methods[key]) {
                throw new Error(
                    'The value to round is not valid. Possibles ["hours", "minutes", "seconds", "milliseconds"]'
                );
            }

            const get = 'get' + methods[key].name;
            const set = 'set' + methods[key].name;

            for (const k in methods) {
                if (k === key) {
                    value = _THIS._d[get]();
                    maxValue = methods[k].maxValue;
                    rounded = true;
                } else if (rounded) {
                    subRatio *= methods[k].maxValue;
                    value += _THIS._d['get' + methods[k].name]() / subRatio;
                    _THIS._d['set' + methods[k].name](0);
                }
            }

            value = Math[direction](value / precision) * precision;
            value = Math.min(value, maxValue);
            _THIS._d[set](value);

            return _THIS;
        };

        moment.fn.ceil = function (precision, key) {
            return this.round(precision, key, 'ceil');
        };

        moment.fn.floor = function (precision, key) {
            return this.round(precision, key, 'floor');
        };
    }
}
